import React, { useState, useEffect } from 'react';
import { Disclaimers, PricePoint, TopLegals, defineMessages, Link } from 'ouisys-component-library';
import { RDS } from 'ouisys-engine/strategy';
import {
  oneClickFlowMatch,
  getRedirectUrlAction,
  subscribeUrlAction,
  IGETREDIRECTURLFailure,
  IGETREDIRECTURLSuccess,
  SubscribeFailure,
  SubscribeSuccess,
  useOneClickFlowState
} from 'ouisys-engine/oneClickFlow';
import { searchToObject } from 'ouisys-engine/utilities/searchToObject';
import { useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import { legals, FormattedMessage } from '../../localization/index';
import { useRootContext } from '../../providers/RootContext';
import { useStrategyState } from 'ouisys-engine/strategy';
import { useDispatch } from '../../__doNotModify/store';
import { tracker } from 'ouisys-engine/utilities/tracker';
import ErrorModal from '../../components/ErrorModal';

// error messages messages which might come from backend
const defaultMessages = defineMessages({
  SubscriptionError: {
    id: 'SubscriptionError',
    defaultMessage: 'Subscription Error!'
  }
});

const SubscribeConfirmButton = () => {
  const dispatch = useDispatch();
  const [isFirstBtnClick, setFirstBtnClick] = useState(false);

  const handleBtnClick = (ev) => {
    ev.preventDefault();

    if (isFirstBtnClick) {
      dispatch(subscribeUrlAction({ window, autoRedirect: true }));
    } else {
      setFirstBtnClick(true);
    }
  };

  return (
    <Link
      allowEvinaClass
      className="subscriptionArea"
      onClick={handleBtnClick}>

      <div className="clickLabel">
        {isFirstBtnClick ? (
          <FormattedMessage id="OneClickConfirmLabel" defaultMessage="Click button below to confirm:" />
        ) : (
          <FormattedMessage id="OneClickSubscribeLabel" defaultMessage="Click button below to subscribe:" />
        )}
      </div>

      <div className={`btn ${isFirstBtnClick ? 'main-btn' : 'submit-button'}`}>
        {isFirstBtnClick ? (
          <FormattedMessage id="PinButton" defaultMessage="One Click btn CTA" />
        ) : (
          <FormattedMessage id="OneClickSubscribeButton" defaultMessage="Subscribe" />
        )}
      </div>

    </Link>
  );
};

const SubscribeThankYou = ({ productUrl }) => (
  <Link
    className="subscriptionArea"
    onClick={() => {
      tracker.advancedInFlow(
        'tallyman.v1-one-click',
        'click-product-url',
        { product_url: productUrl }
      );
    }}
    href={productUrl}
  >
    <div className="clickLabel">
      <FormattedMessage
        id="OneClickSubscribeLabel"
        defaultMessage="Click the button below to subscribe"
      />
    </div>
    <div className="btn">
      <FormattedMessage
        id="OneClickContinueButton"
        defaultMessage="Continue"
      />
    </div>
  </Link>
);

const OneClickFlow = () => {
  const dispatch = useDispatch();
  const oneClickFlowState = useOneClickFlowState(useSelector);
  const strategyState = useStrategyState(useSelector);
  const autoRedirect = false;
  const { locale, shake, setShowModal } = useRootContext();
  const search = searchToObject(window);
  const isAgency = search['partnership_type'] && search['partnership_type'] === 'agency';

  useEffect(() => {
    dispatch(getRedirectUrlAction({
      window,
      autoRedirect,
      isGetRedirectBupperWay: false,
    }));
  }, []);

  // Peru - showModal if there is an error
  const [rdsIsFailure, setRdsIsFailure] = useState<boolean>(false);
  useEffect(() => {
    if (rdsIsFailure) {
      setShowModal(rdsIsFailure);
    }
  }, [rdsIsFailure]);

  return (
    <div className="OneClickFlow">

      {/* top-legals */}
      {/* <TopLegals className="top-legals" locale={locale} legals={legals} /> */}

      {isAgency && (
        <Link id="evina-one-click" className="subscriptionArea" allowEvinaClass isMcp>
          <FormattedMessage id="OneClickLabel" defaultMessage="You are one step closer to complete" />
        </Link>
      )}

      <div id="divFocus" className={shake ? 'shake' : ''}>
        {(!autoRedirect &&
          oneClickFlowMatch({
            getRedirectUrl: (rds) => {
              return (
                <div>
                  {RDS.match<IGETREDIRECTURLFailure, IGETREDIRECTURLSuccess, any>({
                    failure: (err: IGETREDIRECTURLFailure) => console.log(err),
                    nothingYet: () => {
                      // dispatch(getRedirectUrlAction())
                    },
                    loading: () => console.log('loading...'),
                    success: ({ redirectUrl }) => {
                      return (
                        <Link
                          allowEvinaClass
                          isMcp
                          className="subscriptionArea"
                          onClick={() => {
                            tracker.advancedInFlow(
                              'tallyman.v1-one-click',
                              'click-redirect-url',
                              { redirect_url: redirectUrl }
                            );
                          }}
                          href={redirectUrl}
                        >
                          <div className="clickLabel">
                            <FormattedMessage id="OneClickLabel" defaultMessage="You are one step closer to complete" />
                          </div>
                          <div className="btn">
                            <FormattedMessage id="OneClickButton" defaultMessage="Proceed here" />
                          </div>
                        </Link>
                      );
                    }
                  })(rds)}
                </div>
              );
            },
            subscribe: (rds) => {
              const RDSisFailure: boolean = RDS.IsFailure(rds);
              if (RDSisFailure!== rdsIsFailure) {
                setRdsIsFailure(RDSisFailure);
              }
              return (
                <div>
                  {RDS.WhenSuccess<SubscribeSuccess, JSX.Element>(<SubscribeConfirmButton />, (data) => (
                    <SubscribeThankYou {...data} />
                  ))(rds)}
                  {RDS.WhenLoading(null, () => (
                    <div className="loading-wrapper">
                      <Loader />
                      <div>
                        <FormattedMessage id="PleaseWait" defaultMessage="Please wait..." />
                      </div>
                    </div>
                  ))(rds)}
                  {RDS.WhenFailure(null, (err: SubscribeFailure) => (
                    <ErrorModal error={err} />
                  ))(rds)}
                </div>
              );
            }
          })(oneClickFlowState)) || (
          <div className="loading-wrapper">
            <Loader />
            <div>
              <FormattedMessage id="PleaseWait" defaultMessage="Please wait..." />
            </div>
          </div>
        )}
      </div>

      {/* price-point */}
      {/* <PricePoint className="price-point" locale={locale} legals={legals} /> */}

      {/* disclaimers */}
      {/* <Disclaimers className="disclaimer" locale={locale} legals={legals} /> */}

    </div>
  );
};

export default OneClickFlow;
